<script setup lang="ts">
/*
 * Console ambient: the art of whatever tile has the cursor (or the product
 * being viewed) fills the viewport behind the page, blurred and vignetted,
 * crossfading as focus moves. Fed through `useUiStore().setAmbient(url)`;
 * null falls back to a flat ink ground. Mounted once in App.vue for every
 * route. Decorative only.
 */
import { useUiStore } from '../stores/ui';

const ui = useUiStore();
</script>

<template>
  <div class="pointer-events-none fixed inset-0 -z-10 overflow-hidden bg-bg-base" aria-hidden="true">
    <Transition
      enter-active-class="transition-opacity duration-700 ease-out"
      enter-from-class="opacity-0"
      leave-active-class="transition-opacity duration-700 ease-out absolute inset-0"
      leave-to-class="opacity-0"
    >
      <img
        v-if="ui.ambientArt"
        :key="ui.ambientArt"
        :src="ui.ambientArt"
        alt=""
        class="animate-ambient-in absolute inset-0 h-full w-full object-cover opacity-60 blur-3xl saturate-150"
      />
    </Transition>
    <div class="vignette absolute inset-0" />
  </div>
</template>
